module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {

	fox.registerWidget('SitePage_About', {

		init: function() {

			this.embedWidget('twitter', 'Twitter', {
				container: '#twits',
				rpp: 3,
				tpl: {
					row: 'li{if $[_last]}.last{/if}>((span.name>a[href="http://twitter.com/$[authorScreenName]" target="_blank" rel="nofollow"]{$[authorName]: })+span{$[postText]})',
					rowBottom: 'a.view[href="http://twitter.com/$[authorScreenName]" target="_blank" rel="nofollow"]{view more}'
				}
			});

			return this.callParent('init', arguments);
		},

		running: function() {
			this.twitter = this.requireEmbeddedWidget('twitter');
			this.twitter.dl.load();

			this.callParent('running', arguments);
		},


	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/widget/sitepage/about.js
// module id = 132
// module chunks = 4